// extracted by mini-css-extract-plugin
module.exports = {"parent":"DownloadButton_parent__vO7Qm","message":"DownloadButton_message__mVcxn","downloadParent":"DownloadButton_downloadParent__h_R4u"};